import { ComponentProps } from 'react';
import { Field, FieldDescription, FieldError, FieldLabel, Switch } from '@utilities-one/gpm-ui';

import { useFieldContext } from '@/library/form/contexts';
import { FormControlProps } from '@/library/form/types/form.type';

type FormSwitchProps = FormControlProps & {
  switchProps?: ComponentProps<typeof Switch>;
};

export function FormSwitch({ label, description, switchProps }: FormSwitchProps) {
  const field = useFieldContext<boolean>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

  return (
    <Field data-invalid={isInvalid} className="w-fit">
      <div className="flex items-center gap-2">
        <Switch
          {...switchProps}
          id={field.name}
          name={field.name}
          checked={field.state.value}
          onBlur={field.handleBlur}
          onCheckedChange={(checked: boolean) => field.handleChange(checked)}
          aria-invalid={isInvalid}
        />
        <FieldLabel htmlFor={field.name}>{label}</FieldLabel>
      </div>
      {description && <FieldDescription>{description}</FieldDescription>}
      {isInvalid && <FieldError errors={field.state.meta.errors} />}
    </Field>
  );
}
